import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/online_reviews.jpeg")